import { Feature, getFeatureFlag } from '../models/features/features';
import { RootPatronState, usePatronSelector } from './use-patron-selector';

// Migration helper for FE-29692. While `EE.CustomHomepages.Dev` rolls out,
// either flag puts the program on the new patron → optimus → patronus
// homepage path; `Program.CustomHomepages.Enabled` continues to gate the
// studio management screen separately. Once `EE.CustomHomepages.Dev` is at
// 100%, delete this file along with `OldHome` and the rendering-path checks.
export function selectNewHomepageEnabled(state: RootPatronState) {
  return Boolean(
    getFeatureFlag(state, Feature.CUSTOM_HOMEPAGES_DEV) ||
      getFeatureFlag(state, Feature.CUSTOM_HOMEPAGE_ENABLED)
  );
}

export function useNewHomepageEnabled() {
  return usePatronSelector(selectNewHomepageEnabled);
}

export default useNewHomepageEnabled;
